import { UAParser } from 'ua-parser-js';

const parser = new UAParser();
const result = parser.getResult();

export const {browser, cpu, device, engine, os} = result;

export const ua = {
    isChrome: () => isBrowser('Chrome', 'Chrome WebView', 'Chromium'),
    isFirefox: () => isBrowser('Mozilla', 'Firefox'),
    isOpera: () => isBrowser('Opera', 'Opera Mini', 'Opera Mobi', 'Opera Tablet'),
    isSafari: () => isBrowser('Safari', 'Mobile Safari'),
    isIE: () => isBrowser('IE', 'IEMobile'),
    isEdge: () => isBrowser('Edge'),
    isMacOS: () => isOs('Mac OS'),
    isAndroid: () => isOs('Android'),
    isIOS: () => isOs('iOS'),
};

function isBrowser(...names) {
    return names.includes(browser.name);
}

function isOs(...names) {
    return names.includes(os.name);
}



// WEBPACK FOOTER //
// ./src/util/user-agent.js